import { API } from '..';

export interface AffiliateProduct {
  id: string;
  externalId?: string | null;
  network: string;
  title: string;
  thumbnailUrl?: string | null;
  price: number;
  commissionRate: number;
  isActive: boolean;
}

export interface UserStoreItem {
  storeProductId: string;
  productId: string;
  title: string;
  thumbnailUrl?: string | null;
  price: number;
  commissionRate: number;
  deeplink: string;
  trackedLink: string; // link để chia sẻ (đếm click qua Cab redirect)
  clicks: number;
}

export const getAffiliateCatalog = (search?: string, skip = 0, take = 30) =>
  API.get<AffiliateProduct[]>(
    `/v1/payment-service/affiliate/catalog?skip=${skip}&take=${take}${
      search ? `&search=${encodeURIComponent(search)}` : ''
    }`
  ).then((r) => r.data);

export const leakProduct = (productId: string) =>
  API.post<UserStoreItem>(`/v1/payment-service/affiliate/leak/${productId}`).then((r) => r.data);

// Kho sản phẩm NỘI BỘ của Cab (CAB+/voice/cosmetic) — hàng có sẵn, CTV lấy link giới thiệu.
export interface InternalAffiliateProduct {
  key: string;
  title: string;
  category: string;
  priceCa: number;
  commissionPercent: number;
  landingPath: string;
  rarity?: string | null;
}
export const getInternalAffiliateCatalog = () =>
  API.get<InternalAffiliateProduct[]>('/v1/payment-service/affiliate/internal-catalog').then((r) => r.data);

export const getMyShop = () =>
  API.get<UserStoreItem[]>('/v1/payment-service/affiliate/my-shop').then((r) => r.data);

// ── Dashboard affiliate (kiểm soát hoa hồng) ──
export interface Commission {
  id: string;
  productId?: string | null;
  orderRef?: string | null;
  network: string;
  grossCommissionVnd: number;
  userShareVnd: number;
  ca: number;
  status: string; // Pending | Paid | Rejected
  availableAt: string;
  createdAt: string;
  rejectReason?: string | null;
}
export interface EarningsSummary {
  pendingCa: number;
  paidCa: number;
  pendingCount: number;
  nextAvailableAt?: string | null;
}
export interface EarningsDailyPoint {
  date: string;
  commissionCa: number;
  orders: number;
  clicks: number;
}
export interface EarningsStats {
  totalCommissionCa: number;
  totalOrders: number;
  totalClicks: number;
  conversionRate: number; // %
  daily: EarningsDailyPoint[];
}

export const getMyEarnings = () =>
  API.get<EarningsSummary>('/v1/payment-service/affiliate/earnings').then((r) => r.data);

export const getMyCommissions = (status?: string) =>
  API.get<Commission[]>(
    `/v1/payment-service/affiliate/my-commissions${status ? `?status=${status}` : ''}`
  ).then((r) => r.data);

export const getEarningsStats = (days = 14) =>
  API.get<EarningsStats>(`/v1/payment-service/affiliate/earnings-stats?days=${days}`).then((r) => r.data);

export const getPublicShop = (userId: string) =>
  API.get<UserStoreItem[]>(`/v1/payment-service/affiliate/shop/${userId}`).then((r) => r.data);

export const removeFromShop = (storeProductId: string) =>
  API.delete(`/v1/payment-service/affiliate/my-shop/${storeProductId}`).then((r) => r.data);

// Admin
export interface UpsertAffiliateProductPayload {
  id?: string;
  externalId?: string;
  network?: string;
  title: string;
  thumbnailUrl?: string;
  price: number;
  commissionRate: number;
  originalAffiliateLink: string;
  isActive?: boolean;
}
export const adminUpsertAffiliateProduct = (payload: UpsertAffiliateProductPayload) =>
  API.post<AffiliateProduct>('/v1/payment-service/admin/affiliate/products', payload).then((r) => r.data);

// ── Cộng tác viên (đăng ký + duyệt) ──
export interface AffiliatePartner {
  userId: string;
  status: string; // None | Pending | Approved | Rejected
  note?: string | null;
  rejectReason?: string | null;
  appliedAt?: string | null;
  reviewedAt?: string | null;
}

export const applyAffiliatePartner = (note?: string) =>
  API.post<AffiliatePartner>('/v1/payment-service/affiliate/apply', { note }).then((r) => r.data);

export const getAffiliatePartnerStatus = () =>
  API.get<AffiliatePartner>('/v1/payment-service/affiliate/partner-status').then((r) => r.data);

export const adminListAffiliatePartners = (status = 'Pending') =>
  API.get<AffiliatePartner[]>(
    `/v1/payment-service/admin/affiliate/partners?status=${status}`
  ).then((r) => r.data);

export const adminReviewAffiliatePartner = (userId: string, approve: boolean, rejectReason?: string) =>
  API.post<AffiliatePartner>(
    `/v1/payment-service/admin/affiliate/partners/${userId}/review`,
    { approve, rejectReason }
  ).then((r) => r.data);
